import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export const DeleteSessionModal = ({ session, onConfirm, onClose }) => {
    const { t } = useTranslation();

    const isShared = session.visibility && session.visibility !== 'PRIVATE';
    const sessionName = session.name || '';

    return (
        <Modal isOpen toggle={onClose}>
            <ModalHeader toggle={onClose}>{t('agent_chat.delete_title')}</ModalHeader>
            <ModalBody>
                <div className="delete-session-modal">
                    <p className="delete-session-modal__confirm">
                        {t('agent_chat.delete_confirm', { name: sessionName })}
                    </p>
                    <p className="delete-session-modal__warning">
                        {t('agent_chat.delete_warning')}
                    </p>
                    {isShared && (
                        <div className="delete-session-modal__shared-warning">
                            <i className="fas fa-exclamation-triangle"></i>
                            {t('agent_chat.delete_shared_warning')}
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={onClose}>{t('agent_chat.cancel')}</Button>
                <button className="btn delete-session-modal__delete-btn" onClick={onConfirm}>
                    {t('agent_chat.session_menu_delete')}
                </button>
            </ModalFooter>
        </Modal>
    );
};
